var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccordionWrapper',[_c('AccordionItem',[_c('template',{slot:"accordion-trigger"},[_c('div',{staticClass:"form-wrapper__header"},[_c('div',{staticClass:"form-wrapper__title"},[_vm._t("form-title")],2)])]),_c('template',{slot:"accordion-content"},[_vm._t("form-groups")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }